import script from "./Update.vue?vue&type=script&setup=true&lang=js"
export * from "./Update.vue?vue&type=script&setup=true&lang=js"

import "./Update.vue?vue&type=style&index=0&id=416a3ee8&lang=scss"

const __exports__ = script;

export default __exports__